<template>
  <v-container
    v-if="manufacturingSteps"
    class="bordered bg-white">
    <v-row>
      <v-col>
        <DataTable
          :items="manufacturingSteps"
          :headers="headers"
          :summary="summary"
          :extra="{ id: 'index' }" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { t } from "i18next";
import { computed } from "vue";
import { useSpaceStore } from "../../../../stores/spaceStore";

import DataTable from "@/components/Elements/DataTable.vue";

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const spaceStore = useSpaceStore();

const manufacturingSteps = computed(() => {
  return spaceStore.getElementList(props.nodeId, "part");
});

const headers = computed(() => [
  {
    title: "",
    align: "start",
    sortable: false,
    key: "id"
  },
  {
    title: t("entities.manufacturingStep.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t(
      "entities.manufacturingStep.fields.work_system_costs_manufacturing_step_part"
    ),
    key: "work_system_costs_manufacturing_step_part",
    sortable: false
  },
  {
    title: t(
      "entities.manufacturingStep.fields.labour_costs_manufacturing_step_part"
    ),
    key: "labour_costs_manufacturing_step_part",
    sortable: false
  },
  {
    title: t(
      "entities.manufacturingStep.fields.setup_costs_manufacturing_step_part"
    ),
    key: "setup_costs_manufacturing_step_part",
    sortable: true
  },
  {
    title: t("entities.part.fields.tool_and_fixture_costs_part"),
    key: "tool_and_fixture_costs_part",
    sortable: true
  },
  {
    title: t(
      "entities.manufacturingStep.fields.residual_manufacturing_overhead_costs_manufacturing_step_part"
    ),
    key: "residual_manufacturing_overhead_costs_manufacturing_step_part",
    sortable: true
  },
  {
    title: t(
      "entities.manufacturingStep.fields.interest_costs_of_circulating_stocks_manufacturing_step_part"
    ),
    key: "interest_costs_of_circulating_stocks_manufacturing_step_part",
    sortable: true
  },
  {
    title: t(
      "entities.manufacturingStep.fields.manufacturing_scrap_costs_manufacturing_step_part"
    ),
    key: "manufacturing_scrap_costs_manufacturing_step_part",
    // value: (item) => item.interest_costs_on_material_stock_material ?? 0,
    sortable: true
  },
  {
    title: t(
      "entities.manufacturingStep.fields.manufacturing_costs_manufacturing_step_part"
    ),
    key: "manufacturing_costs_manufacturing_step_part",
    sortable: true
  }
]);

const summary = computed(() => {
  return {
    work_system_costs_manufacturing_step_part: manufacturingSteps.value.reduce(
      (sum, item) =>
        sum + Number(item.work_system_costs_manufacturing_step_part),
      0
    ),
    labour_costs_manufacturing_step_part: manufacturingSteps.value.reduce(
      (sum, item) => sum + Number(item.labour_costs_manufacturing_step_part),
      0
    ),
    setup_costs_manufacturing_step_part: manufacturingSteps.value.reduce(
      (sum, item) => sum + Number(item.setup_costs_manufacturing_step_part),
      0
    ),
    tool_and_fixture_costs_part: manufacturingSteps.value.reduce(
      (sum, item) => sum + Number(item.tool_and_fixture_costs_part),
      0
    ),
    residual_manufacturing_overhead_costs_manufacturing_step_part:
      manufacturingSteps.value.reduce(
        (sum, item) =>
          sum +
          Number(
            item.residual_manufacturing_overhead_costs_manufacturing_step_part
          ),
        0
      ),
    interest_costs_of_circulating_stocks_manufacturing_step_part:
      manufacturingSteps.value.reduce(
        (sum, item) =>
          sum +
          Number(
            item.interest_costs_of_circulating_stocks_manufacturing_step_part
          ),
        0
      ),
    manufacturing_scrap_costs_manufacturing_step_part:
      manufacturingSteps.value.reduce(
        (sum, item) =>
          sum + Number(item.manufacturing_scrap_costs_manufacturing_step_part),
        0
      ),
    manufacturing_costs_manufacturing_step_part:
      manufacturingSteps.value.reduce(
        (sum, item) =>
          sum + Number(item.manufacturing_costs_manufacturing_step_part),
        0
      )
  };
});
</script>
